import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as React from 'react';
import {HotKeys} from 'react-hotkeys';

export class FlowKeyboardShortcuts extends React.Component<any, any>
{
    render()
    {
        const {flowKeyboard} = controllers.ui;
        const keyMap = flowKeyboard.getKeyMap();
        const keyHandlers = flowKeyboard.getKeyHandlers();

        return (
            <HotKeys keyMap={keyMap} handlers={keyHandlers} attach={document.body}>
                {this.props.children}
            </HotKeys>
        );
    }
}
